export const cachePatchesKey = "cachePatches";
